import React, { Component } from "react";
import { ReduxConnect, Router } from "../../../toolkit/decorators/Artifact";
import { Helmet } from "react-helmet";
import CancelacionesProcesoComponent from "../../components/cancelacionesProceso/CancelacionesProceso";
import {
  CancelacionesProcesoStore,
  cancelacionesProcesoStore
} from "./CancelacionesProceso.store";
import {
  CancelacionesProcesoDispatcher,
  cancelacionesProcesoDispatcher
} from "./CancelacionesProceso.dispatcher";
import Layout from "../../components/layout";

interface Props
  extends CancelacionesProcesoStore,
    CancelacionesProcesoDispatcher {}
interface State {}

@Router()
@ReduxConnect(cancelacionesProcesoStore, cancelacionesProcesoDispatcher)
export default class CancelacionesProcesoContainer extends Component<
  Props,
  State
> {
  render() {
    return (
      <main>
        <Layout>
          <Helmet title="Cancelaciones en Proceso" />
          <CancelacionesProcesoComponent {...this.props} />
        </Layout>
      </main>
    );
  }
}
